export const PROD = 'production';
export const TEST = 'test';
